import { render } from "./AppRecommendationBanner.vue?vue&type=template&id=9e4681f0&scoped=true"
const script = {}

import "./AppRecommendationBanner.vue?vue&type=style&index=0&id=9e4681f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e4681f0"]])

export default __exports__